import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
// import { fetchMedic } from '../../../api/medics-api';
import { toast } from 'react-toastify';
import { Container } from '../../../../components/content';
import ContentLayout from '../../../../layout/ContentLayout';
import styles from '../../../../styles/viewmedic.module.scss';
import GenericTable from '../../../../components/tables/GenericTable';
import Pagination from '../../../../components/layout/Pagination';
import {
  getClinicMedics,
  getClinicSummary,
  // Clinic referral-commission awarding disabled (2026-08-17): clinics no longer
  // earn or get paid a commission cut — these API calls are commented out too
  // (see api/medics-api.js).
  // getClinicOrders,
  // markClinicPayoutEntryStatus,
  // markClinicPayoutEntriesBulk,
  fetchSingleClinic,
} from '../../../../api/medics-api';
import dayjs from 'dayjs';
import {
  formatPrice,
  formatPriceWithCurrency,
} from '../../../../utils/formatPrice';
import CreateMedicModal from '../../../../components/modals/CreateDoctorModal';
import { Button, ConfigProvider, DatePicker, Dropdown } from 'antd';
import { shrinkText } from '../../../../utils/shrinkText';
// import {
//   PAYOUT_STATUSES,
//   resolvePayoutStatusKey,
//   formatPayoutStatusAsPill,
//   payoutStatusLabel,
// } from '../../../../utils/formatPayoutStatus';
// import BulkMarkPaidConfirmModal from '../../../../components/modals/BulkMarkPaidConfirmModal';

const { RangePicker } = DatePicker;

// Clinic referral-commission awarding disabled (2026-08-17): only used by the
// commission-ledger orders filter, commented out below.
// const payoutStatusOptions = [
//   { label: 'Na čekanju', value: 'pending' },
//   { label: 'Isplaćeno', value: 'paid' },
// ];

const ViewClinic = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { id } = params;
  const [clinicInfo, setClinicInfo] = useState(null);
  const [clinicSummary, setClinicSummary] = useState(null);
  const [clinicDoctorsList, setClinicDoctorsList] = useState([]);
  const [currentPageDoctorsList, setCurrentPageDoctorsList] = useState(1);
  const [totalPagesDoctorsList, setTotalPagesDoctorsList] = useState(1);
  const [isCreateMedicModalOpen, setIsCreateMedicModalOpen] = useState(false);

  // Clinic referral-commission awarding disabled (2026-08-17): "Porudžbine
  // organizacije" (commission-ledger orders) section state/handlers/JSX commented
  // out below — clinics no longer earn or get paid a commission cut.
  // const [clinicOrders, setClinicOrders] = useState([]);
  // const [currentPageOrders, setCurrentPageOrders] = useState(1);
  // const [totalPagesOrders, setTotalPagesOrders] = useState(1);
  // const [orderFilter, setOrderFilter] = useState({
  //   createdFrom: null,
  //   createdTo: null,
  //   payoutStatus: null,
  // });
  // const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  // const [bulkUpdating, setBulkUpdating] = useState(false);
  // const [bulkConfirmOpen, setBulkConfirmOpen] = useState(false);

  const handleCreateMedicModalClose = () => {
    setIsCreateMedicModalOpen(false);
  };

  const onPageChangeDoctorsList = (page) => {
    setCurrentPageDoctorsList(page);
  };

  const dataOrganizationInfo = [
    {
      kupovina: '456.789',
      provizija: '45.678',
      datum: '15.03.2023',
    },
  ];
  const columnsOrganizationInfo = [
    {
      key: 'kupovina',
      label: 'Ukupna vrednost kupovina',
      render: (val, row) => (
        <span>{formatPriceWithCurrency(clinicSummary?.totalRevenue || 0)}</span>
      ),
    },
    // Clinic referral-commission awarding disabled (2026-08-17): clinics no longer
    // earn a commission cut.
    // {
    //   key: 'provizija',
    //   label: 'Ukupna provizija',
    //   render: (val, row) => (
    //     <span>
    //       {formatPriceWithCurrency(clinicSummary?.totalCommissionClinic || 0)}
    //     </span>
    //   ),
    // },
    {
      key: 'datum',
      label: 'Datum dodavanja organizacije',
      render: (val, row) => {
        const date = dayjs(clinicInfo?.createdAt).format('DD.MM.YYYY.');
        return <span>{clinicInfo?.createdAt ? date : ''}</span>;
      },
    },
  ];

  const columnsMedicsList = [
    {
      key: 'imelekara',
      label: 'Ime mentora',
      render: (val, row) => (
        <span>
          {shrinkText(`${row?.doctor?.firstName} ${row?.doctor?.lastName}`, 25)}
        </span>
      ),
    },
    {
      key: 'email',
      label: 'Email',
      render: (val, row) => <span>{shrinkText(row?.doctor?.email, 25)}</span>,
    },
    {
      key: 'kupovina',
      label: 'Ukupno kupovina',
      render: (val, row) => <span>{row?.orders || 0}</span>,
    },
    {
      key: 'vrednost',
      label: 'Vrednost',
      render: (val, row) => (
        <span>{formatPriceWithCurrency(row?.revenue || 0)}</span>
      ),
    },
    {
      key: 'zaradalekara',
      label: 'Zarada mentora',
      render: (val, row) => (
        <span>{formatPriceWithCurrency(row?.doctorCommission || 0)}</span>
      ),
    },
    // Clinic referral-commission awarding disabled (2026-08-17): clinics no longer
    // earn a commission cut.
    // {
    //   key: 'zaradaorganizacije',
    //   label: 'Zarada organizacije',
    //   render: (val, row) => (
    //     <span>{formatPriceWithCurrency(row?.clinicCommission || 0)}</span>
    //   ),
    // },
  ];

  // Rows from /clinics/:id/doctors carry the doctor's id as their _id.
  const medicsListActions = [
    {
      key: 'view',
      label: 'Vidi detalje',
      icon: <img src="/assets/icons/view-icon.svg" alt="Vidi detalje" />,
      onClick: (row) =>
        navigate(`/medics/view/${row._id}`, {
          state: { backTo: `/clinic/view/${id}` },
        }),
    },
  ];

  // Clinic referral-commission awarding disabled (2026-08-17): commission-ledger
  // orders table (columns + row actions) commented out below.
  // const isRowMarkable = (row) =>
  //   !!row?.payoutEntryId && resolvePayoutStatusKey(row) === 'pending';
  //
  // const columnsOrdersInfo = [
  //   {
  //     key: 'imekupca',
  //     label: 'Ime kupca',
  //     render: (val, row) => <span>{row?.customer?.fullName || '-'}</span>,
  //   },
  //   {
  //     key: 'email',
  //     label: 'Email',
  //     render: (val, row) => <span>{row?.customer?.email || '-'}</span>,
  //   },
  //   {
  //     key: 'vrednost',
  //     label: 'Osnovica za proviziju',
  //     render: (val, row) => (
  //       <span>{formatPriceWithCurrency(row?.commissionBase || 0)}</span>
  //     ),
  //   },
  //   {
  //     key: 'provizija',
  //     label: 'Provizija',
  //     render: (val, row) => (
  //       <span>{formatPriceWithCurrency(row?.commissionClinic || 0)}</span>
  //     ),
  //   },
  //   {
  //     key: 'percent',
  //     label: 'Procenat provizije',
  //     render: (val) => <span>{val != null ? `${val}%` : '-'}</span>,
  //   },
  //   {
  //     key: 'chainOwnerName',
  //     label: 'Mentor',
  //     render: (val) => <span>{val || '-'}</span>,
  //   },
  //   {
  //     key: 'payoutStatus',
  //     label: 'Status provizije',
  //     render: (val, row) => formatPayoutStatusAsPill(row),
  //   },
  //   {
  //     key: 'datum',
  //     label: 'Datum kupovine',
  //     render: (val, row) => {
  //       const date = dayjs(row?.createdAt).format('DD.MM.YYYY.');
  //       return <span>{row?.createdAt ? date : '-'}</span>;
  //     },
  //   },
  // ];
  //
  // const orderActions = [
  //   {
  //     key: 'mark-paid',
  //     label: 'Označi proviziju kao isplaćenu',
  //     visible: (row) => isRowMarkable(row),
  //     onClick: (row) => handleMarkEntryStatus(row, 'paid'),
  //   },
  //   {
  //     key: 'mark-pending',
  //     label: 'Označi proviziju kao neisplaćenu',
  //     visible: (row) => !!row?.payoutEntryId && row?.payoutStatus === 'paid',
  //     onClick: (row) => handleMarkEntryStatus(row, 'pending'),
  //   },
  // ];

  const handleFetchClinicSummary = async () => {
    const { data, success, message } = await getClinicSummary(id);

    if (!success) {
      return;
    }
    setClinicSummary(data);
  };

  const handleFetchClinicDoctorsList = async () => {
    const params = {
      page: currentPageDoctorsList,
      limit: 10,
    };
    const { data, success, message } = await getClinicMedics(id, params);

    if (!success) {
      return;
    }
    setClinicDoctorsList(data?.items || []);
    setTotalPagesDoctorsList(data?.totalPages || 1);
    setCurrentPageDoctorsList(data?.currentPage || 1);
  };

  const handleFetchClinicInfo = async () => {
    const { data, success, message } = await fetchSingleClinic(id);

    if (!success) {
      return;
    }

    setClinicInfo(data);
    // console.log('fetch clinic data', data);

    // if (!success) {
    //   toast.error(message || 'Error while fetching the data!');
    //   return;
    // }
    // setData(data);
  };

  // Clinic referral-commission awarding disabled (2026-08-17): commission-ledger
  // orders fetch/filter/mark-paid handlers commented out below.
  // const handleFetchClinicOrders = async () => {
  //   const { data, success, message } = await getClinicOrders(id, {
  //     page: currentPageOrders,
  //     limit: 10,
  //     createdFrom: orderFilter.createdFrom || undefined,
  //     createdTo: orderFilter.createdTo || undefined,
  //     payoutStatus: orderFilter.payoutStatus || undefined,
  //   });
  //
  //   if (!success) {
  //     toast.error(message || 'Greška pri učitavanju porudžbina');
  //     return;
  //   }
  //
  //   setClinicOrders(data?.items || []);
  //   setTotalPagesOrders(data?.totalPages || 1);
  //   setCurrentPageOrders(data?.currentPage || 1);
  //   setSelectedRowKeys([]);
  // };
  //
  // const handleDateRangeChange = (dates) => {
  //   setOrderFilter((prev) => ({
  //     ...prev,
  //     createdFrom: dates?.[0] ? dates[0].startOf('day').toISOString() : null,
  //     createdTo: dates?.[1] ? dates[1].endOf('day').toISOString() : null,
  //   }));
  //   setCurrentPageOrders(1);
  // };
  //
  // const activePayoutStatusLabel = orderFilter.payoutStatus
  //   ? payoutStatusOptions.find((o) => o.value === orderFilter.payoutStatus)
  //       ?.label
  //   : null;
  //
  // const handlePayoutStatusSelect = (value) => {
  //   setOrderFilter((prev) => ({ ...prev, payoutStatus: value }));
  //   setCurrentPageOrders(1);
  // };
  //
  // const handleClearPayoutStatus = (e) => {
  //   e.stopPropagation();
  //   setOrderFilter((prev) => ({ ...prev, payoutStatus: null }));
  //   setCurrentPageOrders(1);
  // };
  //
  // const handleMarkEntryStatus = async (row, status) => {
  //   const { success, message } = await markClinicPayoutEntryStatus(
  //     id,
  //     row.payoutEntryId,
  //     status
  //   );
  //   if (!success) {
  //     toast.error(
  //       message || 'Došlo je do greške pri izmeni statusa provizije.'
  //     );
  //     return;
  //   }
  //   toast.success('Status provizije je ažuriran.');
  //   handleFetchClinicOrders();
  // };
  //
  // const handleBulkMarkPaid = async () => {
  //   // selectedRowKeys are order _ids (GenericTable's row selection always keys
  //   // off row._id), but the bulk-status endpoint operates on commission-ledger
  //   // entry ids — map through the loaded orders to get the right ids, and only
  //   // ones that actually have a markable pending entry.
  //   const entryIds = clinicOrders
  //     .filter((row) => selectedRowKeys.includes(row._id) && isRowMarkable(row))
  //     .map((row) => row.payoutEntryId);
  //
  //   if (entryIds.length === 0) {
  //     toast.error(
  //       'Nijedna od izabranih stavki nema proviziju koja čeka isplatu.'
  //     );
  //     return;
  //   }
  //
  //   setBulkUpdating(true);
  //   const { success, message } = await markClinicPayoutEntriesBulk(
  //     id,
  //     entryIds,
  //     'paid'
  //   );
  //   setBulkUpdating(false);
  //   if (!success) {
  //     toast.error(
  //       message || 'Došlo je do greške pri izmeni statusa provizije.'
  //     );
  //     return;
  //   }
  //   toast.success('Provizija je označena kao isplaćena.');
  //   setSelectedRowKeys([]);
  //   setBulkConfirmOpen(false);
  //   handleFetchClinicOrders();
  // };

  useEffect(() => {
    handleFetchClinicInfo();
    handleFetchClinicSummary();
  }, []);

  useEffect(() => {
    handleFetchClinicDoctorsList();
  }, [currentPageDoctorsList]);

  // Clinic referral-commission awarding disabled (2026-08-17):
  // useEffect(() => {
  //   handleFetchClinicOrders();
  // }, [
  //   currentPageOrders,
  //   orderFilter.createdFrom,
  //   orderFilter.createdTo,
  //   orderFilter.payoutStatus,
  // ]);
  console.log('clinic info', clinicInfo);

  const pillStyle = {
    padding: '4px 12px',
    borderRadius: '16px',
    fontSize: '14px',
    fontWeight: '500',
    display: 'inline-block',
  };

  // Clinic referral-commission awarding disabled (2026-08-17):
  // const selectedMarkableRows = clinicOrders.filter(
  //   (row) => selectedRowKeys.includes(row._id) && isRowMarkable(row)
  // );
  // const selectedMarkableTotal = selectedMarkableRows.reduce(
  //   (sum, row) => sum + (row.commissionClinic || 0),
  //   0
  // );

  return (
    <>
      <Container className={styles.medic}>
        <Link to={'/korisnici?tab=organizacije'} className="link_btn">
          <img alt="back image" src="/assets/icons/chevron.svg" />
          <span>Nazad</span>
        </Link>
        <div>
          <ContentLayout pt={true}>
            <div className={styles.medic__content}>
              <div className={styles.medic__inner}>
                <p className="title"></p>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <p className="title">Organizacija: {clinicInfo?.name}</p>
                  {/* Clinic referral-commission awarding disabled (2026-08-17):
                  clinics no longer earn a commission cut.
                  <span
                    style={{
                      ...pillStyle,
                      backgroundColor: '#ECFDF3',
                      color: '#027A48',
                    }}
                  >
                    {clinicSummary?.commissionPercent != null
                      ? `Provizija ${clinicSummary.commissionPercent}%`
                      : 'Provizija -'}
                  </span> */}
                </div>
                <GenericTable
                  data={dataOrganizationInfo}
                  columns={columnsOrganizationInfo}
                  grayTheme={false}
                  mobNoScroll={false}
                />
              </div>
              <div className={styles.medic__inner}>
                <div className={styles.medic__inner__header}>
                  <p className="title">Lista mentora u organizaciji</p>
                  <Button
                    className={`btn-primary`}
                    type="primary"
                    onClick={() => setIsCreateMedicModalOpen(true)}
                  >
                    Dodaj mentora
                  </Button>
                </div>
                <GenericTable
                  data={clinicDoctorsList}
                  columns={columnsMedicsList}
                  actions={medicsListActions}
                  grayTheme={false}
                  mobNoScroll={false}
                />
                <Pagination
                  currentPage={currentPageDoctorsList}
                  totalPages={totalPagesDoctorsList}
                  onPageChange={onPageChangeDoctorsList}
                />
              </div>
              {/* Clinic referral-commission awarding disabled (2026-08-17): commission-ledger "Porudžbine organizacije" section commented out below.
              <div className={styles.medic__inner}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '16px',
                    flexWrap: 'wrap',
                    gap: '8px',
                  }}
                >
                  <p className="title" style={{ margin: 0 }}>
                    Porudžbine organizacije
                  </p>

                  <div
                    style={{
                      display: 'flex',
                      gap: '8px',
                      alignItems: 'center',
                      flexWrap: 'wrap',
                    }}
                  >
                    <ConfigProvider
                      theme={{
                        token: {
                          colorPrimary: '#005844',
                          controlOutline: 'rgba(0, 88, 68, 0.1)',
                          colorPrimaryHover: '#004636',
                        },
                        components: {
                          DatePicker: {
                            activeBorderColor: '#005844',
                            hoverBorderColor: '#005844',
                          },
                        },
                      }}
                    >
                      <RangePicker
                        format="DD.MM.YYYY"
                        onChange={handleDateRangeChange}
                        placeholder={['Datum od', 'Datum do']}
                        allowClear
                      />
                    </ConfigProvider>
                    <Dropdown
                      menu={{
                        items: payoutStatusOptions.map((option) => ({
                          key: option.value,
                          label: option.label,
                          onClick: () => handlePayoutStatusSelect(option.value),
                        })),
                      }}
                      trigger={['click']}
                      placement="bottomLeft"
                      className="btn-filter-container"
                    >
                      <Button
                        className={`btn-tertiary btn-filter ${orderFilter.payoutStatus ? 'active' : ''}`}
                      >
                        {activePayoutStatusLabel
                          ? `Provizija: ${activePayoutStatusLabel}`
                          : 'Status provizije'}
                        {orderFilter.payoutStatus && (
                          <img
                            src="/assets/icons/x-gray.svg"
                            title="Ukloni filter"
                            style={{
                              width: '10px',
                              height: '10px',
                              marginLeft: '5px',
                              cursor: 'pointer',
                            }}
                            alt="Ukloni filter"
                            onClick={handleClearPayoutStatus}
                          />
                        )}
                      </Button>
                    </Dropdown>
                    {selectedRowKeys.length > 0 && (
                      <>
                        <Button
                          className="btn-primary"
                          disabled={
                            bulkUpdating || selectedMarkableRows.length === 0
                          }
                          onClick={() => setBulkConfirmOpen(true)}
                        >
                          {bulkUpdating
                            ? 'Ažuriranje...'
                            : `Označi ${selectedMarkableRows.length} kao realizovano`}
                        </Button>
                      </>
                    )}
                  </div>
                </div>
                <div
                  className={styles.payoutLegend}
                  style={{ justifyContent: 'flex-end', marginBottom: '12px' }}
                >
                  {PAYOUT_STATUSES.map((s) => (
                    <span key={s.key} className={styles.legendItem}>
                      <span
                        className={`${styles.payoutDot} ${styles[s.key] || ''}`}
                      />
                      {s.label}
                    </span>
                  ))}
                </div>
                <GenericTable
                  data={clinicOrders}
                  columns={columnsOrdersInfo}
                  grayTheme={false}
                  mobNoScroll={false}
                  actions={orderActions}
                  rowClassName={(row) =>
                    row.payoutStatus === 'paid' ? 'row--paid' : ''
                  }
                  rowSelection={{
                    selectedRowKeys,
                    onChange: setSelectedRowKeys,
                    getCheckboxProps: (row) => ({
                      disabled: !isRowMarkable(row),
                      title: payoutStatusLabel(row),
                    }),
                  }}
                />
                <Pagination
                  currentPage={currentPageOrders}
                  totalPages={totalPagesOrders}
                  onPageChange={setCurrentPageOrders}
                />
              </div> */}
            </div>
          </ContentLayout>
        </div>
      </Container>
      <CreateMedicModal
        isOpen={isCreateMedicModalOpen}
        onClose={handleCreateMedicModalClose}
        onCreate={handleFetchClinicDoctorsList}
        singleClinic={clinicInfo?._id}
        // clinics={allClinics}
      />
      {/* Clinic referral-commission awarding disabled (2026-08-17):
      <BulkMarkPaidConfirmModal
        visible={bulkConfirmOpen}
        onClose={() => setBulkConfirmOpen(false)}
        onConfirm={handleBulkMarkPaid}
        count={selectedMarkableRows.length}
        totalAmount={selectedMarkableTotal}
        loading={bulkUpdating}
      /> */}
    </>
  );
};

export default ViewClinic;
